import i18n from 'i18n-js';
import * as types from './types';
import { uiActions } from 'state/modules/UI';
import * as tasksActions from 'services/api/tasks';
import { getErrorMessage, parsePagination, isCancel } from 'utils';

// Get Tasks
const fetchTasksRequest = () => ({
  type: types.FETCH_TASKS_REQUEST,
});

const fetchTasksSuccess = (payload) => ({
  type: types.FETCH_TASKS_SUCCESS,
  payload,
});

const fetchTasksFailed = () => ({
  type: types.FETCH_TASKS_FAILED,
});

export const fetchTasks = (params = {}, options) => {
  if (params.statuses === 'ALL_ACTIVE') {
    params.statuses = ['OPEN', 'APPROVED', 'INPROGRESS', 'PENDING_APPROVAL'];
  } else if (params.statuses === 'ALL_INACTIVE') {
    params.statuses = ['CANCELLED', 'COMPLETED'];
  }

  return async (dispatch) => {
    dispatch(fetchTasksRequest());

    const response = await tasksActions.fetchTasks(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchTasksSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    if (!isCancel(response)) {
      const error = getErrorMessage(response.data);

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: error,
        })
      );

      dispatch(fetchTasksFailed(error));
    }
  };
};

// Create Tasks
const fetchCreateTaskRequest = () => ({
  type: types.FETCH_CREATE_TASK_REQUEST,
});

const fetchCreateTaskSuccess = (payload) => ({
  type: types.FETCH_CREATE_TASK_SUCCESS,
  payload,
});

const fetchCreateTaskFailed = () => ({
  type: types.FETCH_CREATE_TASK_FAILED,
});

export const fetchCreateTask = (payload = {}, handleSuccess) => {
  return async (dispatch) => {
    dispatch(fetchCreateTaskRequest());

    const response = await tasksActions.fetchCreateTask(payload);

    if (response.ok) {
      if (handleSuccess()) handleSuccess();
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('tasks.task_created'),
        })
      );
      return dispatch(fetchCreateTaskSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchCreateTaskFailed(error));
  };
};

// GET TASK BY ID
const fetchTaskByIdRequest = () => ({
  type: types.FETCH_TASK_BY_ID_REQUEST,
});

const fetchTaskByIdSuccess = (payload) => ({
  type: types.FETCH_TASK_BY_ID_SUCCESS,
  payload,
});

const fetchTaskByIdFailed = () => ({
  type: types.FETCH_TASK_BY_ID_FAILED,
});

export const fetchTaskById = (id) => {
  return async (dispatch) => {
    dispatch(fetchTaskByIdRequest());

    const response = await tasksActions.fetchTaskById(id);

    if (response.ok) {
      return dispatch(fetchTaskByIdSuccess(response?.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchTaskByIdFailed());
  };
};

// UPDATE TASK
const fetchUpdateTaskRequest = () => ({
  type: types.FETCH_UPDATE_TASK_REQUEST,
});

const fetchUpdateTaskSuccess = (payload) => ({
  type: types.FETCH_UPDATE_TASK_SUCCESS,
  payload,
});

const fetchUpdateTaskFailed = () => ({
  type: types.FETCH_UPDATE_TASK_FAILED,
});

export const fetchUpdateTask = (id, payload = {}, handleSuccess) => {
  return async (dispatch) => {
    dispatch(fetchUpdateTaskRequest());

    const response = await tasksActions.fetchUpdateTask(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('tasks.task_updated'),
        })
      );
      if (handleSuccess) {
        handleSuccess();
      }
      return dispatch(fetchUpdateTaskSuccess(response?.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchUpdateTaskFailed());
  };
};

export const resetCurrentTask = () => (dispatch) => {
  return dispatch({ type: types.RESET_CURRENT_TASK });
};
